import { Component, EventEmitter, Input, Output } from '@angular/core';
import { OrderQuoteDTO } from '../../interfaces/order-quote';

@Component({
  selector: 'b2c-price-display',
  templateUrl: 'b2c-price-display.component.html',
  styleUrls: ['b2c-widget.component.scss', 'b2c-price-display.component.scss'],
})
export class B2cPriceDisplayComponent {
  // @Input() isBillingPage: boolean;
  // @Input() showDiscountPrice: boolean;
  // @Input() yourQuotePrice: number;
  // @Input() yourQuotePriceWithVAT: number;
  // @Input() yourOriginalPrice: number;
  // @Input() yourOriginalPriceInclVAT: number;
  // @Input() totalSaving: number;
  // @Input() discountCodeIsValid: boolean;
  // @Input() discountText: string;
  // @Input() discountCode: string;

  @Input() quote: OrderQuoteDTO;

  public get yourQuotePrice(): number {
    return this.quote.bookUrgent ? this.quote.urgentPrice : this.quote.standardPrice;
  }

  public get yourOriginalPrice(): number {
    return this.yourQuotePrice + this.discountAmount;
  }

  public get discountAmount(): number {
    return this.quote.bookUrgent
      ? this.quote.urgentDiscountAmount
      : this.quote.standardDiscountAmount;
  }

  public get showDiscountPrice(): boolean {
    return this.discountAmount > 0;
  }

  @Output() showDiscountCodeDialog: EventEmitter<boolean>;

  constructor() {
    this.showDiscountCodeDialog = new EventEmitter<boolean>();
  }

  showDialog() {
    this.showDiscountCodeDialog.emit();
  }
}
